import React from 'react'

const HayleeCV = () => {
  return (
    <>
      <h1 className='temp-h1'>CV/Resume</h1>
    </>
  )
}

export default HayleeCV